import { Component } from '@angular/core';

@Component({
  selector: 'app-mediacenter',
  templateUrl: './mediacenter.component.html',
  styleUrl: './mediacenter.component.scss'
})
export class MediacenterComponent {

}
